import React from 'react'
import { Route, Redirect } from 'react-router-dom';
import AuthService from '../AuthService';

export default function PrivateRoute({ component: Component, ...rest }) {
    return (
        <Route
            {...rest}
            render={props =>
                AuthService.hasToken() ? (
                    <Component {...props} model={rest.model} title={rest.title} />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: { from: props.location }
                        }}
                    />
                )
            }
        />
    );
}

